import Modal from "@components/Modal";
import LockersMapWithFilters from "@components/LockersMapWithFilters";

const LockersMapWithFiltersModal = ({
  modalId,
  mapId,
  header,
  onLockerSelect,
}) => (
  <Modal
    id={modalId}
    size="large"
    header={header || "Alege un punct de ridicare favorit"}
  >
    <LockersMapWithFilters mapId={mapId} onLockerSelect={onLockerSelect} />
  </Modal>
);

export default LockersMapWithFiltersModal;
